import { SVGProps } from 'react';

export enum IconSize {
  xs = 8,
  s = 12,
  m = 16,
  l = 20,
  xl = 24,
}

export enum IconRotation {
  Up = 0,
  Right = 90,
  Down = 180,
  Left = 270,
}

export type IconDeclaration =
  | { path: SVGProps<SVGPathElement> }
  | { rect: SVGProps<SVGRectElement> }
  | { circle: SVGProps<SVGCircleElement> }
  | { ellipse: SVGProps<SVGEllipseElement> }
  | { polygon: SVGProps<SVGPolygonElement> }
  | { polyline: SVGProps<SVGPolylineElement> }
  | { line: SVGProps<SVGLineElement> };
